import type { UnitInfoAddInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';

export enum nbrOfInputs {
  TWO = 2,
  THREE = 3,
  FOUR = 4,
}

/**
 * Returns the default unitinfo object for a Add unit
 */
export const getDefaultData = (
  noInputs: number = nbrOfInputs.TWO,
): UnitInfoAddInterface => {
  return {
    unitName: 'Add',
    nbrOfInputs: noInputs,
    angle: 0,
    display: {},
  };
};

export class AddConfig extends BaseUnitConfig {
  getDefaultData(params?: UnitConfigParams): UnitInfoAddInterface {
    const variantId = params?.variantId ?? nbrOfInputs.TWO;

    return {
      unitName: 'Add',
      nbrOfInputs: variantId,
      angle: 0,
      display: {},
    };
  }

  getNumberOfPorts(model?: string, variantId?: number): number {
    const numInputs = variantId ?? nbrOfInputs.TWO;
    return numInputs + 1;
  }
}

export const addConfig = new AddConfig();
